import { render, staticRenderFns } from "./LinkProductLevelForm.vue?vue&type=template&id=38c9be00&scoped=true"
import script from "./LinkProductLevelForm.vue?vue&type=script&lang=js"
export * from "./LinkProductLevelForm.vue?vue&type=script&lang=js"
import style0 from "./LinkProductLevelForm.vue?vue&type=style&index=0&id=38c9be00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c9be00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VSelect,VTextField})
